import '../../components/Alignment.css';
import '../../DataTable.css';
import '../../../../core/components/app-root/AppRoot.css';
import '../../components/DataTableVirtualizationContainer.css';
import '../RowOrder/RowOrder.css';
import '../RowDetails/RowDetails.css';
import '../RowInteractivity/RowInteractivity.css';
import '../../components/DataTableRow.css';
import '../Thresholds/Thresholds.css';
import '../../components/DataTableCell.css';
import '../ColumnOrder/ColumnOrder.css';
import '../../components/DataTableHeaderCell.css';
import '../../components/DataTableDefaultCell.css';
import './Sorting.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var multiSortIndicatorBubble = '_cu1al70-3-5-0';
export var sortOrderIndicator = '_cu1al71-3-5-0';
export var sortingArrow = _7a468({defaultClassName:'_cu1al72-3-5-0',variantClassNames:{arrowUp:{true:'_cu1al73-3-5-0'},rowDensity:{'default':'_cu1al74-3-5-0',condensed:'_cu1al75-3-5-0',comfortable:'_cu1al76-3-5-0'}},defaultVariants:{},compoundVariants:[]});